import React, { FC } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCoffee } from '@fortawesome/free-solid-svg-icons'

const News: FC = () => {
	return (
		<div>
		NEWS
			<FontAwesomeIcon icon={faCoffee} />
		</div>
	)
}

export default News
